import React, { useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, IconButton } from '@mui/material';
import { useEnvironment } from '../../../../../../contexts/EnvironmentContext';
import { toast } from 'react-toastify';
import { Timestamp } from 'firebase/firestore';
import { generateMD5Hash, generateSHA1Hash } from '../utils/hashs';

const TestDataSection = ({ handleFieldChange, setHasChanges, disabled }) => {
  const { isDevelopmentEnv } = useEnvironment();
  
  // Create the base values first
  const carValue = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const baseYearStartDate = Timestamp.fromDate(new Date("2023-01-01 03:00:00"));
  const baseYearEndDate = Timestamp.fromDate(new Date("2024-01-01 03:00:00"));
  
  const [testData, setTestData] = useState({
    address: {
      propertyName: "Test Farm",
      city: "Test City",
      state: "TS",
      country: "Brazil",
      latitude: "-15.7801",
      longitude: "-47.9292"
    },
    baseYear: {
      endDate: baseYearEndDate,
      startDate: baseYearStartDate
    },
    car: carValue,
    carbonCredit: 123456,
    certificationKey: generateMD5Hash(carValue + baseYearStartDate.toDate().toISOString() + baseYearEndDate.toDate().toISOString()),
    creationCode: generateMD5Hash(carValue + baseYearStartDate.toDate().toISOString() + baseYearEndDate.toDate().toISOString()),
    date: Timestamp.fromDate(new Date()),
    matriculation: [],
    currentMatriculation: "1234",
    owners: [
      {
        docId: "848.303.950-87",
        docType: "CPF",
        fullName: "Test User",
      }
    ],
    propertyArea: 1000,
    registrationDate: Timestamp.fromDate(new Date()),
    requester: {
      fullName: "Test User",
      email: "test@example.com",
      phone: "+55 61 99999-9999",
    },
    status: {
      custody: "ABCARBON"
    },
    userKey: generateSHA1Hash("848.303.950-87"),
  });

  const handlePopulateData = () => {
    // Update all fields
    Object.entries(testData).forEach(([key, value]) => {
      if (typeof value === 'object' && !(value instanceof Timestamp)) {
        Object.entries(value).forEach(([subKey, subValue]) => {
          handleFieldChange(`${key}.${subKey}`, subValue);
        });
      } else {
        handleFieldChange(key, value);
      }
    });

    setHasChanges(true);
    toast.success('Test data populated successfully');
  };

  if (!isDevelopmentEnv) return null;

  return (
    <Grid item xs={12}>
      <Button
        variant="outlined"
        color="warning"
        onClick={handlePopulateData}
        disabled={disabled}
        fullWidth
      >
        Populate Test Data
      </Button>
    </Grid>
  );
};

export default TestDataSection; 